<template>
  <div class="page">
    <div class="page-title">预约看房</div>
    <el-form :inline="true" :model="query" class="toolbar">
      <el-form-item>
        <el-date-picker
          v-model="query.visitDate"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="预约日期"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.status" size="small" clearable placeholder="状态">
          <el-option label="待确认" value="待确认"></el-option>
          <el-option label="已确认" value="已确认"></el-option>
          <el-option label="已取消" value="已取消"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border size="small" v-loading="loading">
      <el-table-column label="提交用户" width="160">
        <template slot-scope="scope">
          <div class="submit-user">
            <img v-if="scope.row.userUrl" :src="scope.row.userUrl" class="avatar" referrerpolicy="no-referrer">
            <span v-else class="avatar-ph"></span>
            <span>{{ scope.row.userName || '—' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="listingType" label="类型" width="80" :formatter="fmtType"></el-table-column>
      <el-table-column prop="listingId" label="房源ID" min-width="160"></el-table-column>
      <el-table-column prop="visitDate" label="预约日期" width="120"></el-table-column>
      <el-table-column prop="timeSlot" label="时段" width="110"></el-table-column>
      <el-table-column prop="phone" label="电话" width="130"></el-table-column>
      <el-table-column prop="status" label="状态" width="100"></el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="170" :formatter="fmtTime"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button v-if="canConfirm(scope.row)" type="text" size="mini" @click="setStatus(scope.row, '已确认')">确认</el-button>
          <el-button v-if="canCancel(scope.row)" type="text" size="mini" @click="setStatus(scope.row, '已取消')">取消</el-button>
          <span v-if="!canConfirm(scope.row) && !canCancel(scope.row)" class="muted">—</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :child-msg="pageparm" @callFather="onPage"></Pagination>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { visitPage, updateVisitStatus, pageBody } from '../../api/spAdmin'
export default {
  components: { Pagination },
  data() {
    return {
      loading: false,
      list: [],
      query: { status: '', visitDate: '' },
      pageparm: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created() { this.load() },
  methods: {
    fmtType(row, col, val) {
      return val === 'sale' ? '买卖' : '租赁'
    },
    fmtTime(row, col, val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 19)
    },
    canConfirm(row) {
      return row && row.status !== '已确认' && row.status !== '已取消'
    },
    canCancel(row) {
      return row && row.status !== '已取消'
    },
    search() {
      this.pageparm.currentPage = 1
      this.load()
    },
    onPage(p) {
      this.pageparm.currentPage = p.currentPage
      this.pageparm.pageSize = p.pageSize
      this.load()
    },
    load() {
      this.loading = true
      visitPage({
        page: this.pageparm.currentPage,
        limit: this.pageparm.pageSize,
        status: this.query.status,
        visitDate: this.query.visitDate
      }).then(res => {
        if (!res || res.status !== 200) {
          this.list = []
          this.pageparm.total = 0
          this.loading = false
          this.$message.error((res && res.message) || '列表加载失败')
          return
        }
        const body = pageBody(res)
        this.list = body.list
        this.pageparm.total = body.total
        this.loading = false
      }, () => { this.loading = false })
    },
    setStatus(row, status) {
      if (row.status === '已取消') {
        this.$message.warning('该预约已取消，不能再改状态')
        return
      }
      if (status === '已确认' && row.status === '已确认') {
        return
      }
      updateVisitStatus(row.id, status).then(res => {
        if (!res || res.status !== 200) {
          this.$message.error((res && res.message) || '更新失败')
          return
        }
        this.$message.success('已更新')
        this.load()
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.page { padding: 8px 4px 24px; }
.page-title { font-size: 20px; font-weight: 800; color: #1f1633; margin-bottom: 16px; }
.toolbar { background: #fff; padding: 12px 12px 0; border-radius: 12px; margin-bottom: 12px; }
.muted { color: #9b95ae; font-size: 12px; }
.submit-user { display: flex; align-items: center; }
.avatar, .avatar-ph { width: 28px; height: 28px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; }
.avatar { object-fit: cover; }
.avatar-ph { background: #e8edf3; display: inline-block; }
</style>



// WEBPACK FOOTER //
// src/views/housing/visitList.vue